import { useState } from "react";
import { Button, Tabs, Tab, Card, CardBody } from "react-bootstrap";
import { motion } from "framer-motion";

function Admision() {
  const [selectedTab, setSelectedTab] = useState("proceso");

  return (
    <div className="container text-center" data-aos="fade-up">
      <div className="mt-5">
          <h1>Pre-inscripciones 2026</h1>
      </div>
      {/* Submenú de navegación con Tabs */}
      <Tabs activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} className="mb-3 " data-aos="fade-up">
        <Tab eventKey="proceso" title="Proceso de Admisión">
          <Card className="shadow-lg mb-4 text-start bg-light p-4 rounded-4 shadow-sm">
            <CardBody>
 
              <h4  className="alert alert-danger fw-bold fs-5 rounded-3">IMPORTANTE</h4>
              <p>Las pre-inscripciones 2026 están abiertas para:</p>
              <ul className="list-unstyled">
                <li>✅ Nivel Inicial</li>
                <li>✅ Nivel Primario</li>
                <li>✅ Nivel Secundario</li>
              </ul>
      
 
            </CardBody>
          </Card>
        </Tab>

        <Tab eventKey="calendario" title="Calendario de Admisiones">
          <Card className="shadow-lg mb-4 text-start bg-light p-4 rounded-4 shadow-sm">
            <CardBody>
 
              <h4 className="fw-bold text-primary">Fechas Importantes</h4>
              <ul>
                <li>📅 Inscripciones abiertas desde Mayo 2025.</li>
                <li>📅 Entrega de documentación hasta Junio 2025.</li>
                <li>📅 Entrevistas en Mayo / Junio  2025.</li>
                
 
              </ul>
            </CardBody>
          </Card>
        </Tab>

        <Tab eventKey="matriculacion" title="Matriculación">
          <Card className="shadow-lg mb-4 text-start bg-light p-4 rounded-4 shadow-sm">
            <CardBody>
              <h4  className="alert alert-success fw-bold fs-5 rounded-3">Proceso de Matriculación</h4>
              <p>
                Una vez admitidos, los estudiantes deberán completar el proceso de matriculación, que incluye:
              </p>
              <ul className="list-unstyled mt-3 mb-4">
                <li className="d-flex align-items-center mb-2">📌 Pago de matrícula.</li>
                <li className="d-flex align-items-center mb-2">📌 Presentación de documentos requeridos.</li>
                <li className="d-flex align-items-center mb-2">📌 Confirmación de vacante.</li>
              </ul>
            </CardBody>
          </Card>
        </Tab>

        <Tab eventKey="faq" title="Preguntas Frecuentes">
          <Card className="shadow-lg mb-4 text-start bg-light p-4 rounded-4 shadow-sm">
            <CardBody>
              <h4 className="alert alert-info fw-bold fs-5 rounded-3">Preguntas Frecuentes</h4>
              <p><strong className="fw-bold">¿Cuáles son los requisitos de ingreso?</strong><br/>Los requisitos varían por nivel educativo. Contacta con la institución para más detalles.</p>
              <p><strong className="fw-bold">¿Se ofrecen becas?</strong><br/>Sí, hay becas disponibles para familias con necesidad económica.</p>
              <p><strong className="fw-bold">¿Cuándo inician las clases?</strong><br/>El ciclo lectivo inicia en marzo de cada año.</p>
            </CardBody>
          </Card>
        </Tab>
      </Tabs>

 
        {/* Botón para descargar la planilla */}
<motion.div
  initial={{ opacity: 0, y: 10 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5, delay: 0.2 }}
>
  <a
    href="https://linktr.ee/colegiosantotomas?fbclid=PAZXh0bgNhZW0CMTEAAadsaLyc2I9JX8Kq4W3SFBzx5QJywqDOtLNjhU5FXfnSZE_DybS_Wdf-a0nHjQ_aem_Hssm0DvkYrM5If49GAp9lg"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Button variant="warning" className="mt-5 px-4 py-2 text-lg shadow-lg">
      📄 Descargar Planilla
    </Button>
  </a>
</motion.div>
 
      
    </div>
  );
}

export default Admision;
